var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTrainingLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3D82F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.836 17.283h4.491c.084-.402.134-.821.134-1.257a5.693 5.693 0 0 0-5.698-5.698h-5.731a5.693 5.693 0 0 0-5.698 5.698v.302a5.38 5.38 0 0 0 2.748 4.692c.1.05.168.15.151.268-.033 1.123-.218 2.028-.67 2.933.855-.1 2.095-1.173 2.782-2.363.05-.1.15-.15.251-.15h1.693a5.7 5.7 0 0 1 5.547-4.425",
    fill: "#F8FAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.283 22.98a5.693 5.693 0 0 0-5.698-5.698h-1.257a5.68 5.68 0 0 1-5.547 4.442h-4.492a6 6 0 0 0-.134 1.256 5.693 5.693 0 0 0 5.698 5.698h5.765c.151 0 .285 0 .436-.017.72 1.006 1.76 1.844 2.497 1.928-.386-.754-.57-1.508-.654-2.397a5.7 5.7 0 0 0 3.386-5.212",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingLanguage);
export default __webpack_public_path__ + "static/media/TrainingLanguage.208890ca0cc0c981cd6082fb7dbfcfa6.svg";
export { ForwardRef as ReactComponent };